import type {
  AgentDTO,
  CreateAgentInput,
  HandoffSettingsDTO,
  OnlineStatus,
  OwnerTelegramBotDTO,
  RegisterTelegramBotInput,
  TeamSummary,
  TelegramLinkCodeResponse,
  TelegramSummaryDTO,
  UpdateAgentInput,
  UpdateHandoffSettingsInput,
  WsTicketResponse,
} from '@bruno/shared';
import { api } from './client';

export function listTeamAgents(): Promise<TeamSummary> {
  return api<TeamSummary>('/v1/team/agents');
}

export function createAgent(body: CreateAgentInput): Promise<AgentDTO> {
  return api<AgentDTO>('/v1/team/agents', { method: 'POST', body });
}

export function updateAgent(id: string, body: UpdateAgentInput): Promise<AgentDTO> {
  return api<AgentDTO>(`/v1/team/agents/${id}`, { method: 'PATCH', body });
}

export function deleteAgent(id: string): Promise<void> {
  return api<void>(`/v1/team/agents/${id}`, { method: 'DELETE' });
}

export function setMyPresence(status: OnlineStatus): Promise<void> {
  return api<void>('/v1/team/presence', { method: 'POST', body: { status } });
}

export function getWsTicket(): Promise<WsTicketResponse> {
  return api<WsTicketResponse>('/v1/team/ws-ticket', { method: 'POST' });
}

// ---------- Handoff settings (owner-only writes) ----------

export function getHandoffSettings(): Promise<HandoffSettingsDTO> {
  return api<HandoffSettingsDTO>('/v1/team/handoff-settings');
}

export function updateHandoffSettings(
  body: UpdateHandoffSettingsInput,
): Promise<HandoffSettingsDTO> {
  return api<HandoffSettingsDTO>('/v1/team/handoff-settings', {
    method: 'PUT',
    body,
  });
}

// ---------- Telegram bot + per-agent link ----------

export function getTelegramSummary(): Promise<TelegramSummaryDTO> {
  return api<TelegramSummaryDTO>('/v1/team/telegram');
}

export function registerTelegramBot(
  body: RegisterTelegramBotInput,
): Promise<OwnerTelegramBotDTO> {
  return api<OwnerTelegramBotDTO>('/v1/team/telegram/bot', {
    method: 'POST',
    body,
  });
}

export function deleteTelegramBot(): Promise<void> {
  return api<void>('/v1/team/telegram/bot', { method: 'DELETE' });
}

export function requestTelegramLinkCode(): Promise<TelegramLinkCodeResponse> {
  return api<TelegramLinkCodeResponse>('/v1/team/telegram/link-code', {
    method: 'POST',
  });
}

export function unlinkTelegram(): Promise<void> {
  return api<void>('/v1/team/telegram/link', { method: 'DELETE' });
}
